import { CalendarX2, ChevronRight, Copy, MoreHorizontal } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { CampaignDto } from '@/generated/korza-api-client/types.gen';
import { useI18nContext } from '@/i18n/i18n-react';
import { canCancelCampaign } from '@/lib/campaign-list';

/**
 * ⋯ of a campaign row in the desktop table (PUSH-04 AC 2): Duplicar,
 * Cancelar (only while not sent) and Ver detalhes. Duplicar and Cancelar show
 * only when the table was given their handlers.
 */
export function CampaignRowActionsMenu({
  campaign,
  viewDetailsLabel,
  onViewDetails,
  onDuplicate,
  onCancel,
}: {
  campaign: CampaignDto;
  viewDetailsLabel: string;
  onViewDetails(campaign: CampaignDto): void;
  onDuplicate?: (campaign: CampaignDto) => void;
  onCancel?: (campaign: CampaignDto) => void;
}) {
  const { LL } = useI18nContext();

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          className="h-8 w-8 p-0"
          aria-label={LL.campaigns.card.moreActions({ name: campaign.name })}
        >
          <MoreHorizontal className="h-4 w-4" aria-hidden />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {onDuplicate && (
          <DropdownMenuItem onSelect={() => onDuplicate(campaign)}>
            <Copy className="h-4 w-4" aria-hidden />
            {LL.campaigns.actionsSheet.duplicate()}
          </DropdownMenuItem>
        )}
        {onCancel && canCancelCampaign(campaign) && (
          <DropdownMenuItem
            className="text-destructive focus:text-destructive"
            onSelect={() => onCancel(campaign)}
          >
            <CalendarX2 className="h-4 w-4" aria-hidden />
            {LL.campaigns.actionsSheet.cancel()}
          </DropdownMenuItem>
        )}
        <DropdownMenuItem onSelect={() => onViewDetails(campaign)}>
          <ChevronRight className="h-4 w-4" aria-hidden />
          {viewDetailsLabel}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
